import { render, staticRenderFns } from "./Evento_deporte_live.vue?vue&type=template&id=73bd034c&scoped=true&"
import script from "./Evento_deporte_live.vue?vue&type=script&lang=js&"
export * from "./Evento_deporte_live.vue?vue&type=script&lang=js&"
import style0 from "./Evento_deporte_live.vue?vue&type=style&index=0&id=73bd034c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bd034c",
  null
  
)

export default component.exports